/**
 * Utilities to get information about the current environment
 */
export var getEnv = function getEnv(key) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var env = typeof process !== 'undefined' && process ? process.env || {} : {};

  if (!key) {
    /* istanbul ignore next */
    return env;
  }

  return env[key] || fallback;
};
export var getNoWarn = function getNoWarn() {
  return getEnv('BOOTSTRAP_VUE_NO_WARN') || getEnv('NODE_ENV') === 'production';
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/env.js
// module id = 1432
// module chunks = 1